import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';

function DetailSkeleton({
  height = 360,
  width = '100%',
  maxWidth = '100%',
}) {
  return (
    <Box
      data-testid="detail-skeleton"
      sx={{
        width,
        maxWidth,
        minHeight: height,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.25,
        p: 1.25,
        boxSizing: 'border-box',
      }}
    >
      <Stack direction="row" spacing={0.75}>
        <Skeleton variant="rounded" width={72} height={22} />
        <Skeleton variant="rounded" width={64} height={22} />
        <Skeleton variant="rounded" width={74} height={22} />
      </Stack>
      <Skeleton variant="text" width="62%" height={30} />
      <Skeleton variant="text" width="40%" height={18} />
      <Box sx={{ pt: 1 }}>
        <Skeleton variant="text" width={110} height={16} />
        <Skeleton variant="text" width="96%" height={22} />
        <Skeleton variant="text" width="88%" height={22} />
        <Skeleton variant="text" width="72%" height={22} />
      </Box>
      <Box sx={{ pt: 1 }}>
        <Skeleton variant="text" width={100} height={16} />
        {[96, 92, 98, 84, 76].map((lineWidth, index) => (
          <Skeleton key={lineWidth + index} variant="text" width={`${lineWidth}%`} height={20} />
        ))}
      </Box>
    </Box>
  );
}

export default DetailSkeleton;
